import {FC} from 'react'

interface Props {
  status: number
}

const RoleStatusCell: FC<Props> = ({status}) => {
  const getStatusBadgeClass = () => {
    return status === 1 ? 'badge-light-success' : 'badge-light-danger'
  }

  const getStatusText = () => {
    return status === 1 ? 'Active' : 'Inactive'
  }

  return (
    <div className='badge badge-light-success fw-bolder'>
      <span className={`badge ${getStatusBadgeClass()} fw-bolder`}>{getStatusText()}</span>
    </div>
  )
}

export {RoleStatusCell} 